"use strict";

angular.module("diceApp").directive("lowercase", () => {
  return {
    link: (scope, element) => {
      element.css("text-transform", "lowercase");
    }
  };
});
